var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "confirm-snackbar", attrs: { id: _vm.id } }, [
    _c("p", [_vm._v(_vm._s(_vm.message))]),
    _c(
      "button",
      {
        staticClass: "btn btn-primary btn-sm",
        attrs: { type: "button" },
        on: {
          click: function ($event) {
            return _vm.callback()
          },
        },
      },
      [_vm._v(" " + _vm._s(_vm.$t("yes")) + " ")]
    ),
    _c(
      "button",
      {
        staticClass: "btn btn-secondary btn-sm",
        attrs: { type: "button" },
        on: {
          click: function ($event) {
            return _vm.dismiss()
          },
        },
      },
      [_vm._v(" " + _vm._s(_vm.$t("no")) + " ")]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }